import script from "./PersonCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonCard.vue?vue&type=script&setup=true&lang=js"

import "./PersonCard.vue?vue&type=style&index=0&id=b82e4c4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b82e4c4e"]])

export default __exports__